import { GET_MPN_PROCESS_CONDITIONS } from "./getMpnProcessContitions";

export const helpStepCondition = (
  step: number,
  state:any
): { messages: string; isReady: boolean } => {

  const stepConditions = GET_MPN_PROCESS_CONDITIONS;

  const messages: string[] = [];
  //@ts-ignore
  stepConditions[step]?.forEach((s: any) => {
    if (!s.condition(state)) {
      messages.push(s.message);
    }
  });

  return { messages: messages.join("<br />"), isReady: messages.length > 0 };
};